import type { TFilterOptionsRule } from '../mappers';
import type { IDirectoriesStorage } from 'src/services/directories-storage-service/directories-storage-service';
import type { TComboBoxView, TMultiComboBoxView } from 'src/services/directory-service/types';

import { compareDataWithFilterItems } from './compare-data-with-filter-items';
import { mapFilterRuleItems } from './map-filter-rule-items';

export const handleFilterOptionsRule = (
  directoryService: IDirectoriesStorage,
  record: Record<string, unknown>,
  depControlView: TComboBoxView | TMultiComboBoxView,
  rule: TFilterOptionsRule,
): { allowedOptions: Record<number | string, boolean> | null } => {
  const allowedOptions: Record<number, boolean> = {};

  const directoryRecords = directoryService.directories[depControlView.refObjectType];

  const filters = mapFilterRuleItems(rule.ruleView.filterRules, directoryService, record);

  for (const directoryRecord of directoryRecords) {
    if (compareDataWithFilterItems({ ...directoryRecord.data, id: directoryRecord.id }, filters)) {
      allowedOptions[directoryRecord.id] = true;
    }
  }

  return {
    allowedOptions,
  };
};
